import { WarningCircleIcon } from '@phosphor-icons/react';

import { useContent } from '@/content/ContentContext';
import { BUDGET_RANGES, TIMELINES } from '@/domain/brief/BriefOptions';
import type { BriefWizardController } from '@/features/brief/useBriefWizard';
import { ChoiceChip } from '@/ui/Form/Choice';

import styles from '../Brief.module.css';

export function ScopeStep({ controller }: { readonly controller: BriefWizardController }) {
  const { brief } = useContent();
  const { wizard } = controller;
  const { budget, timeline } = wizard.values;

  return (
    <fieldset className={styles.step}>
      <legend className="visually-hidden">{brief.steps.scope.title}</legend>
      <h3 className={styles.question} tabIndex={-1} data-step-heading id="brief-budget">
        {brief.budgetQuestion}
      </h3>
      <div className={styles.chips} role="group" aria-labelledby="brief-budget">
        {BUDGET_RANGES.map((range) => (
          <ChoiceChip
            key={range}
            selected={budget === range}
            onSelect={() => {
              controller.update('budget', range);
            }}
          >
            {brief.budgets[range].label}
          </ChoiceChip>
        ))}
      </div>

      <h3 className={styles.question} id="brief-timeline">
        {brief.timelineQuestion}
      </h3>
      <div className={styles.chips} role="group" aria-labelledby="brief-timeline">
        {TIMELINES.map((option) => (
          <ChoiceChip
            key={option}
            selected={timeline === option}
            onSelect={() => {
              controller.update('timeline', option);
            }}
          >
            {brief.timelines[option].label}
          </ChoiceChip>
        ))}
      </div>

      {wizard.notice === 'scope' && (
        <p className={styles.notice} role="alert" data-step-notice>
          <WarningCircleIcon size={18} aria-hidden="true" />
          {brief.errors.scope}
        </p>
      )}
    </fieldset>
  );
}
